module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescirp1-e582e8972b21c8075479c0329a7817ff.jpg";